import { defineMessages } from "react-intl";

import {
	diagnosisBaselineDiseaseMessages,
	kidneyCoreBiopsyMessages,
	validator
} from "lib/build/forms/ktx/basic-registration-data/waiting-list-data/kidneyDiseaseEthiology";

import { FieldData, FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	kidneyDiseaseEthiology: {
		id: "ktx.form.kidneyDiseaseEthiology.title",
		defaultMessage: "Vesebetegség diagnózisa"
	},
	baseline: {
		id: "ktx.form.kidneyDiseaseEthiology.baseline",
		defaultMessage: "Vese alapbetegség diagnózis (EDTA)"
	},
	biopsy: {
		id: "ktx.form.kidneyDiseaseEthiology.biopsy",
		defaultMessage: "Vesebiopszia"
	},
	biopsyComment: {
		id: "ktx.form.kidneyDiseaseEthiology.biopsy_comment",
		defaultMessage: "Vesebiopszia megjegyzés"
	}
});

const baselineField: FieldData = {
	type: "field",
	path: ["diagnosisBaselineDisease"],
	label: messages.baseline,
	errorMessages: genericErrorMessages,
	input: {
		type: "select",
		props: { labels: diagnosisBaselineDiseaseMessages }
	}
};

const biopsyField: FieldData = {
	type: "field",
	path: ["kidneyBiopsy", "kidneyCoreBiopsy"],
	label: messages.biopsy,
	errorMessages: genericErrorMessages,
	input: {
		type: "button-group",
		props: { labels: kidneyCoreBiopsyMessages }
	}
};

const biopsyCommentField: FieldData = {
	type: "field",
	path: ["kidneyBiopsy", "kidneyCoreBiopsyComment"],
	label: messages.biopsyComment,
	errorMessages: genericErrorMessages,
	input: {
		type: "textarea",
		props: {}
	}
};

const fieldset: FieldsetData = {
	rows: [
		{ columns: [{ width: 12, field: baselineField }] },
		{ columns: [{ width: 12, field: biopsyField }] },
		{
			columns: [{ width: 12, field: biopsyCommentField }]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_kidneyDiseaseEthiology",
	value: {
		schemaId: "kidneyDiseaseEthiology",
		title: messages.kidneyDiseaseEthiology,
		validator,
		fieldset,
		applyCurrentDate: false,
		initialValue: { diagnoses: [{}] }
	}
};
